// ダイアログの表示と非表示の切り替え
document.addEventListener('DOMContentLoaded', function() {
  const shiseidoDialog = document.getElementById('s-dialog');
  // const shiseidoOpen = document.querySelectorAll('.s_open-dialog-button');
  const shiseidoCloseButtons = document.querySelectorAll('.js-s-closeButton');

  // ダイアログを表示する
  // shiseidoOpen.forEach(function(shiseidoOpenButton) {
  //   shiseidoOpenButton.addEventListener('click', function() {
  //     shiseidoDialog.showModal();
  //   });
  // });

  // ダイアログを閉じるボタンに対するイベントリスナーを追加
  shiseidoCloseButtons.forEach(function(shiseidoClose) {
    shiseidoClose.addEventListener('click', function() {
      shiseidoDialog.close();
    });
  });

  // ダイアログ外をクリックした場合にダイアログを閉じる
  shiseidoDialog.addEventListener('click', function(event) {
    if (event.target === shiseidoDialog) {
      shiseidoDialog.close();
    }
  });
});

// 質問の表示/非表示と次へのボタンの有効化ロジック
document.addEventListener('DOMContentLoaded', function() {
  const question1Yes = document.getElementById('s_q1_1');
  const question1No = document.getElementById('s_q1_2');
  const question2Yes = document.getElementById('s_q2_1');
  const question2No = document.getElementById('s_q2_2');
  const question3Yes = document.getElementById('s_q3_1');
  const question3No = document.getElementById('s_q3_2');
  const question2Wrap = document.querySelectorAll('.s-dialog__questionWrap')[1];
  const question3Wrap = document.querySelectorAll('.s-dialog__questionWrap')[2];
  const nextButton = document.querySelector('.js-s-nextButton');
  const questionWrapper = document.querySelector('.s-dialog__questionWrapper');
  const resultWrapper = document.querySelector('.s-dialog__resultWrapper');
  const resultComplete = document.querySelector('.s-dialog__result--complete');
  const resultImpossible = document.querySelector('.s-dialog__result--impossible');
  const resultAttention = document.querySelector('.s-dialog__result--attention');

  // 初期設定で質問2と質問3を非表示にする
  question2Wrap.style.display = 'none';
  question3Wrap.style.display = 'none';

  // すべての質問が回答されたかをチェックし、次へのボタンを有効化する
  function checkAllAnswered() {
    if ((question1Yes.checked && question2No.checked) || 
        (question1No.checked && (question3Yes.checked || question3No.checked)) || 
        (question2Yes.checked && (question3Yes.checked || question3No.checked))) {
      nextButton.style.backgroundColor = '#1e293b'; // 次へのボタンを有効化
    } else {
      nextButton.style.backgroundColor = ''; // 次へのボタンを無効化
    }
  }

  // 質問1で「はい」を選択した場合の処理
  question1Yes.addEventListener('change', function() {
    question2Wrap.style.display = 'block'; // 質問2を表示
    question3Wrap.style.display = 'none'; // 質問3を非表示
    question3Yes.checked = false;
    question3No.checked = false;
    checkAllAnswered();
  });

  // 質問1で「いいえ」を選択した場合の処理
  question1No.addEventListener('change', function() {
    question2Wrap.style.display = 'none'; // 質問2を非表示
    question3Wrap.style.display = 'block'; // 質問3を表示
    question2Yes.checked = false;
    question2No.checked = false;
    checkAllAnswered();
  });

  // 質問2で「はい」を選択した場合の処理
  question2Yes.addEventListener('change', function() {
    question3Wrap.style.display = 'block'; // 質問3を表示
    checkAllAnswered();
  });

  // 質問2で「いいえ」を選択した場合の処理
  question2No.addEventListener('change', function() {
    question3Wrap.style.display = 'none'; // 質問3を非表示
    question3Yes.checked = false;
    question3No.checked = false;
    checkAllAnswered();
  });

  // 質問3の選択肢に変化があった場合の処理
  question3Yes.addEventListener('change', checkAllAnswered);
  question3No.addEventListener('change', checkAllAnswered);

  // 次へのボタンをクリックした際の処理
  nextButton.addEventListener('click', function() {
    if ((question1Yes.checked && question2No.checked) || 
        (question1No.checked && (question3Yes.checked || question3No.checked)) || 
        (question2Yes.checked && (question3Yes.checked || question3No.checked))) {
      questionWrapper.style.display = 'none'; // 質問部分を非表示
      resultWrapper.style.display = 'block'; // 結果部分を表示
      resultComplete.style.display = 'none';
      resultImpossible.style.display = 'none';
      resultAttention.style.display = 'none';

      if (question1Yes.checked && question2No.checked) {
        resultImpossible.style.display = 'block'; // 購入不可メッセージを表示
      } else if (question1No.checked && question3No.checked) {
        resultComplete.style.display = 'block'; // 購入可能メッセージを表示
      } else {
        resultAttention.style.display = 'block'; // 注意メッセージを表示
      }
    }
  });

  // 「もう一度チェックする」ボタンをクリックした際の処理
  document.querySelector('.js-s-againButton').addEventListener('click', function() {
    resultWrapper.style.display = 'none';
    questionWrapper.style.display = 'block';
    resultImpossible.style.display = 'none';
    question2Wrap.style.display = 'none';
    question3Wrap.style.display = 'none';
    question1Yes.checked = false;
    question1No.checked = false;
    question2Yes.checked = false;
    question2No.checked = false;
    question3Yes.checked = false;
    question3No.checked = false;
    nextButton.style.backgroundColor = '';
  });

  // 「カートに追加する」ボタンをクリックした際の処理
  document.querySelectorAll('.product-form__submit').forEach(button => {
    button.addEventListener('click', function() {
      const dialog = document.getElementById('s-dialog');
      dialog.close(); // ダイアログを閉じる
    });
  });
});

// 未ログイン時：「ログインしてカートに追加」ボタン押下時の処理
// ボタン押下 → ログイン要求ポップアップを重ねて表示 → ポップアップ内「ログイン」押下でログイン画面へ遷移
document.addEventListener('DOMContentLoaded', function() {
  const COUNSELING_STORAGE_KEY = 'yayoiCpbCounselingState';
  const dialog = document.getElementById('s-dialog');
  if (!dialog) {
    return;
  }

  const loginRequiredDialog = document.getElementById('s-login-required-dialog');
  let pendingCounselingResult = null;

  function redirectToLogin() {
    const returnTo = window.location.pathname + window.location.search;
    sessionStorage.setItem(COUNSELING_STORAGE_KEY, JSON.stringify({
      productId: dialog.dataset.productId,
      result: pendingCounselingResult,
      returnTo: returnTo,
    }));
    window.location.href = '/account/login?return_to=' + encodeURIComponent(returnTo);
  }

  document.querySelectorAll('.js-s-login-cart-button').forEach(function(button) {
    button.addEventListener('click', function() {
      pendingCounselingResult = button.dataset.counselingResult;
      if (loginRequiredDialog) {
        loginRequiredDialog.showModal();
      } else {
        redirectToLogin();
      }
    });
  });

  if (loginRequiredDialog) {
    const loginConfirmButton = loginRequiredDialog.querySelector('.js-s-login-required-confirm');
    if (loginConfirmButton) {
      loginConfirmButton.addEventListener('click', redirectToLogin);
    }

    // ポップアップ外をクリックした場合に閉じる
    loginRequiredDialog.addEventListener('click', function(event) {
      if (event.target === loginRequiredDialog) {
        loginRequiredDialog.close();
      }
    });
  }

  // ログイン後の再訪問時：保存されたカウンセリング完了状態を復元する
  const savedStateRaw = sessionStorage.getItem(COUNSELING_STORAGE_KEY);
  if (!savedStateRaw) {
    return;
  }
  sessionStorage.removeItem(COUNSELING_STORAGE_KEY);

  let savedState;
  try {
    savedState = JSON.parse(savedStateRaw);
  } catch (e) {
    return;
  }

  if (!savedState || savedState.productId !== dialog.dataset.productId) {
    return;
  }

  const questionWrapper = document.querySelector('.s-dialog__questionWrapper');
  const resultWrapper = document.querySelector('.s-dialog__resultWrapper');
  const resultComplete = document.querySelector('.s-dialog__result--complete');
  const resultAttention = document.querySelector('.s-dialog__result--attention');
  const resultImpossible = document.querySelector('.s-dialog__result--impossible');

  if (savedState.result !== 'complete' && savedState.result !== 'attention') {
    return;
  }

  questionWrapper.style.display = 'none';
  resultWrapper.style.display = 'block';
  resultImpossible.style.display = 'none';
  resultComplete.style.display = savedState.result === 'complete' ? 'block' : 'none';
  resultAttention.style.display = savedState.result === 'attention' ? 'block' : 'none';

  dialog.showModal();

  // showModal() はダイアログ内の最初のフォーカス可能要素（「トータルカウンセリングを希望する」リンク）に
  // 自動的にフォーカスを当ててしまうため、意図しないフォーカスを解除する
  if (document.activeElement instanceof HTMLElement && document.activeElement.classList.contains('s-dialog__c_Button')) {
    document.activeElement.blur();
  }
});
